/**
 * @author       sammy.dowds@zumper.com (Sammy Dowds)
 * @copyright    Copyright (c) 2022, Zumper
 */

import { IS_SERVER } from '@zcode/env'
import type { GetState } from '@zcode/state-type'
import type { History } from 'history'
import type { Dispatch } from 'redux'
import { confirmEmailChange } from './confirmEmailChange'
export enum ExternalThunksKeys {
  confirmEmailChange = 'confirmEmailChange',
}
export const thunksExternal =
  () =>
  async (dispatch: Dispatch, getState: GetState, { history }: { history: History }) => {
    if (IS_SERVER) {
      return
    }
    const searchParams = new URLSearchParams(history.location.search)
    const thunksExternalAction = searchParams.get('thunksExternal')

    if (!thunksExternalAction) {
      return
    }
    if (thunksExternalAction === ExternalThunksKeys.confirmEmailChange) {
      await dispatch(confirmEmailChange({ token: searchParams.get('token') }))
    }
  }
